<template>
    <header class="room-topbar">
        <div class="room-topbar-left">
            <div class="room-logo">
                <img src="../assets/images/tb.png" alt="帽子戴歪歪">
            </div>
            <div class="room-brand">
                <span class="room-brand-name">帽子戴歪歪</span>
            </div>
        </div>
        <div class="room-topbar-actions">
            <button
                type="button"
                class="room-icon-btn"
                :class="{ 'is-on': compactMode }"
                title="全屏 / 简洁模式"
                @click="$emit('toggle-compact')">
                <mu-icon :value="compactMode ? 'fullscreen_exit' : 'fullscreen'" :size="22"></mu-icon>
            </button>
            <button
                type="button"
                class="room-icon-btn"
                :class="{ 'is-on': showChat }"
                title="显示 / 隐藏聊天"
                @click="$emit('toggle-chat')">
                <mu-icon :value="showChat ? 'chat' : 'chat_bubble_outline'" :size="22"></mu-icon>
            </button>
            <button
                type="button"
                class="room-icon-btn"
                title="搜索点歌"
                @click="$emit('search')">
                <mu-icon value="search" :size="22"></mu-icon>
            </button>
            <button
                type="button"
                class="room-icon-btn room-share-btn"
                title="分享房间"
                @click="$emit('share')">
                <svg class="room-share-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M8 9H7.2A2.2 2.2 0 0 0 5 11.2v7.6A2.2 2.2 0 0 0 7.2 21h8.6A2.2 2.2 0 0 0 18 18.8V16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14 4h6v6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M11 13L20 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>分享</span>
            </button>
            <button
                type="button"
                class="room-icon-btn"
                title="个人设置"
                @click="$emit('profile')">
                <mu-icon value="person_outline" :size="22"></mu-icon>
            </button>
            <button
                v-if="showCookie"
                type="button"
                class="room-icon-btn"
                :class="{ 'has-alert': cookieAlert }"
                :title="cookieAlert ? '音乐服务需要留意' : '管理员状态面板'"
                @click="$emit('cookie')">
                <mu-icon value="vpn_key" :size="20"></mu-icon>
            </button>
        </div>
    </header>
</template>

<script>
    export default {
        name: "Navigation",
        props: {
            showChat: {
                type: Boolean,
                default: true
            },
            compactMode: {
                type: Boolean,
                default: false
            },
            cookieAlert: { type: Boolean, default: false },
            showCookie: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>
.room-icon-btn.has-alert { position: relative; }
.room-icon-btn.has-alert::after { content: ''; position: absolute; top: 5px; right: 5px; width: 7px; height: 7px; border-radius: 50%; background: var(--room-danger); }
</style>
